import { useTranslation } from 'react-i18next';
import hhLogo from '@/assets/images/happy-hearts-logo.svg';
import { HAPPY_HEARTS_SITE_URL } from '@/components/happyHeartsSite';

type Props = {
  light?: boolean;
};

const RLogo = ({ light }: Props) => {
  const { t } = useTranslation();
  return (
    <a
      className={`rg-logo${light ? ' rg-logo-light' : ''}`}
      href={HAPPY_HEARTS_SITE_URL}
      aria-label={`${t('wreg.logo.alt')} home`}
    >
      <img className="rg-logo-svg" src={hhLogo} alt={t('wreg.logo.alt')} />
    </a>
  );
};

export { RLogo };
